(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fb-avaliacoes"] && !Shopify.designMode) return;
  try {
    
/* Ordenacao no cliente. Nao ha backend de avaliacoes aqui, entao o select so
   reordena os blocos que ja estao na pagina. Sem biblioteca externa. */
(function () {
  function valorData(el) {
    var v = el.getAttribute('data-ts') || '';
    return v; // AAAA-MM-DD ordena bem como texto
  }

  function nota(el) {
    return parseInt(el.getAttribute('data-score'), 10) || 0;
  }

  function ordem(el) {
    return parseInt(el.getAttribute('data-ordem'), 10) || 0;
  }

  function aplica(lista, criterio) {
    var itens = Array.prototype.slice.call(lista.querySelectorAll('.jdgm-rev'));
    itens.sort(function (a, b) {
      var d;
      if (criterio === 'maior' || criterio === 'menor') {
        d = nota(b) - nota(a);
        if (criterio === 'menor') d = -d;
        if (d !== 0) return d;
      }
      // desempate e criterio padrao: data mais recente primeiro
      var da = valorData(a);
      var db = valorData(b);
      if (da && db && da !== db) return da < db ? 1 : -1;
      // sem data confiavel, mantem a ordem em que o dono montou os blocos
      return ordem(a) - ordem(b);
    });
    itens.forEach(function (item) {
      lista.appendChild(item);
    });
  }

  function liga(raiz) {
    var widgets = (raiz || document).querySelectorAll('.jdgm-rev-widg');
    Array.prototype.forEach.call(widgets, function (widget) {
      var select = widget.querySelector('[data-fb-ordenar]');
      var lista = widget.querySelector('.jdgm-rev-widg__reviews');
      if (!select || !lista || select.dataset.fbLigado === '1') return;
      select.dataset.fbLigado = '1';
      select.addEventListener('change', function () {
        aplica(lista, select.value);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { liga(); });
  } else {
    liga();
  }
  // Editor de temas: a secao e reinjetada sem recarregar a pagina.
  document.addEventListener('shopify:section:load', function (e) { liga(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fb-garantias-lp"] && !Shopify.designMode) return;
  try {
    
// Reproduz o data-scroll-to do botao original: sem link preenchido, o botao
// rola ate a caixa de compra em vez de navegar.
document.addEventListener('click', function (evento) {
  var botao = evento.target.closest ? evento.target.closest('[data-fb-garlp-alvo]') : null;
  if (!botao) return;
  var alvo = null;
  try {
    alvo = document.querySelector(botao.getAttribute('data-fb-garlp-alvo'));
  } catch (erro) {
    alvo = null;
  }
  if (!alvo) return;
  evento.preventDefault();
  alvo.scrollIntoView({ behavior: 'smooth', block: 'center' });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fb-hero-lp"]) return;
  try {
    
/* fb-hero-lp: contador regressivo, carrossel e barra fixa. Vanilla, sem dependencia.
   Reinicializa em shopify:section:load para funcionar no editor de temas. */
(function () {
  function doisDigitos(n) { return n < 10 ? '0' + n : String(n); }

  function leia(chave) {
    try { return window.localStorage.getItem(chave); } catch (e) { return null; }
  }
  function grave(chave, valor) {
    try { window.localStorage.setItem(chave, valor); } catch (e) { /* modo privado */ }
  }

  /* contador regressivo com duracao em horas e reinicio opcional ao zerar.
     Sem data fixa: o prazo nasce na primeira visita e fica no navegador. */
  function montaRelogio(sec) {
    var hrs = sec.querySelectorAll('.js-phr-timer-hrs');
    var min = sec.querySelectorAll('.js-phr-timer-min');
    var seg = sec.querySelectorAll('.js-phr-timer-sec');
    if (!hrs.length && !min.length && !seg.length) return;

    var horas = parseFloat(sec.getAttribute('data-fb-horas'));
    if (!horas || horas <= 0) { horas = 12; }
    var reiniciar = sec.getAttribute('data-fb-reiniciar') === 'true';
    var duracao = horas * 3600000;
    var chave = 'fb-hlp-prazo-' + sec.getAttribute('data-fb-secao');

    var prazo = parseInt(leia(chave), 10);
    var agora = Date.now();
    if (!prazo || isNaN(prazo) || prazo - agora > duracao) {
      prazo = agora + duracao;
      grave(chave, String(prazo));
    }

    function escreve(lista, texto) {
      for (var i = 0; i < lista.length; i++) { lista[i].textContent = texto; }
    }

    function pinta() {
      var resta = prazo - Date.now();
      if (resta <= 0) {
        if (reiniciar) {
          prazo = Date.now() + duracao;
          grave(chave, String(prazo));
          resta = duracao;
        } else {
          resta = 0;
        }
      }
      var t = Math.floor(resta / 1000);
      escreve(hrs, doisDigitos(Math.floor(t / 3600)));
      escreve(min, doisDigitos(Math.floor((t % 3600) / 60)));
      escreve(seg, doisDigitos(t % 60));
    }

    pinta();
    if (sec.fbHlpTimer) { clearInterval(sec.fbHlpTimer); }
    sec.fbHlpTimer = setInterval(pinta, 1000);
  }

  /* carrossel: o original usa Swiper. Aqui e scroll-snap nativo no trilho,
     com setas e miniaturas ligadas pelo indice. */
  function montaGaleria(sec) {
    var galeria = sec.querySelector('[data-fb-hlp-galeria]');
    if (!galeria) return;
    var trilho = galeria.querySelector('[data-fb-hlp-trilho]');
    if (!trilho) return;

    var slides = galeria.querySelectorAll('[data-fb-hlp-slide]');
    var minis = galeria.querySelectorAll('[data-fb-hlp-mini]');
    var ant = galeria.querySelector('[data-fb-hlp-ant]');
    var prox = galeria.querySelector('[data-fb-hlp-prox]');
    if (!slides.length) return;

    function indiceAtual() {
      var largura = slides[0].offsetWidth || 1;
      return Math.round(trilho.scrollLeft / largura);
    }

    function vaiPara(i) {
      var max = slides.length - 1;
      if (i < 0) { i = max; }
      if (i > max) { i = 0; }
      trilho.scrollTo({ left: slides[0].offsetWidth * i, behavior: 'smooth' });
      marca(i);
    }

    /* a classe ativa e a mesma que a Swiper usaria, por causa do CSS copiado */
    function marca(i) {
      for (var k = 0; k < minis.length; k++) {
        if (k === i) {
          minis[k].classList.add('swiper-slide-thumb-active');
          if (minis[k].scrollIntoView) {
            minis[k].scrollIntoView({ block: 'nearest', inline: 'nearest' });
          }
        } else {
          minis[k].classList.remove('swiper-slide-thumb-active');
        }
      }
    }

    if (slides.length < 2) {
      if (ant) { ant.style.display = 'none'; }
      if (prox) { prox.style.display = 'none'; }
    } else {
      if (ant) { ant.addEventListener('click', function () { vaiPara(indiceAtual() - 1); }); }
      if (prox) { prox.addEventListener('click', function () { vaiPara(indiceAtual() + 1); }); }
    }

    for (var k = 0; k < minis.length; k++) {
      (function (alvo) {
        alvo.addEventListener('click', function () {
          vaiPara(parseInt(alvo.getAttribute('data-fb-hlp-mini'), 10) || 0);
        });
      })(minis[k]);
    }

    var espera = null;
    trilho.addEventListener('scroll', function () {
      if (espera) { clearTimeout(espera); }
      espera = setTimeout(function () { marca(indiceAtual()); }, 90);
    }, { passive: true });

    marca(0);
  }

  /* caixa de avaliacoes que rola ate a secao de reviews */
  function montaAncora(sec) {
    var gatilhos = sec.querySelectorAll('[data-scroll-to]');
    for (var i = 0; i < gatilhos.length; i++) {
      (function (el) {
        el.addEventListener('click', function () {
          var alvo = null;
          try { alvo = document.querySelector(el.getAttribute('data-scroll-to')); } catch (e) { alvo = null; }
          if (alvo) { alvo.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
        });
      })(gatilhos[i]);
    }
  }

  /* barra fixa: aparece quando a sentinela (bloco do botao) sai por cima */
  function montaBarra(sec) {
    var barra = sec.querySelector('[data-fb-hlp-sticky]');
    var alvo = sec.querySelector('[data-fb-hlp-sentinela]');
    if (!barra || !alvo) return;

    function mostra(ligado) {
      if (ligado) {
        barra.classList.add('reskin-sticky-cta--visible');
        barra.setAttribute('aria-hidden', 'false');
      } else {
        barra.classList.remove('reskin-sticky-cta--visible');
        barra.setAttribute('aria-hidden', 'true');
      }
      var botao = barra.querySelector('button');
      if (botao) { botao.setAttribute('tabindex', ligado ? '0' : '-1'); }
    }

    if (!('IntersectionObserver' in window)) { return; }
    if (sec.fbHlpObs) { sec.fbHlpObs.disconnect(); }
    sec.fbHlpObs = new IntersectionObserver(function (entradas) {
      for (var i = 0; i < entradas.length; i++) {
        var e = entradas[i];
        mostra(!e.isIntersecting && e.boundingClientRect.top < 0);
      }
    }, { threshold: 0, rootMargin: '0px' });
    sec.fbHlpObs.observe(alvo);
  }

  function iniciar(raiz) {
    var escopo = raiz && raiz.querySelectorAll ? raiz : document;
    var secoes = escopo.querySelectorAll('[data-fb-hlp]');
    for (var i = 0; i < secoes.length; i++) {
      var sec = secoes[i];
      if (sec.fbHlpPronta) { continue; }
      sec.fbHlpPronta = true;
      montaRelogio(sec);
      montaGaleria(sec);
      montaAncora(sec);
      montaBarra(sec);
    }
  }

  window.fbHlpIniciar = iniciar;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { iniciar(document); });
  } else {
    iniciar(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target.querySelector ? e.target.querySelector('[data-fb-hlp]') : null;
    if (sec) { sec.fbHlpPronta = false; }
    iniciar(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var sec = e.target.querySelector ? e.target.querySelector('[data-fb-hlp]') : null;
    if (!sec) return;
    if (sec.fbHlpTimer) { clearInterval(sec.fbHlpTimer); sec.fbHlpTimer = null; }
    if (sec.fbHlpObs) { sec.fbHlpObs.disconnect(); sec.fbHlpObs = null; }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fb-kit"] && !Shopify.designMode) return;
  try {
    
/* fb-kit: carrossel com rolagem nativa. As setas so dao um scrollBy de um card
   e a barra de progresso acompanha o scroll. Sem biblioteca, e sem tocar no
   layout: quem posiciona tudo e o CSS de fb-secoes.css. */
(function () {
  function passoDe(trilha) {
    var card = trilha.querySelector('.fb-kit__card');
    if (!card) return trilha.clientWidth;
    var estilo = window.getComputedStyle(trilha);
    var vao = parseFloat(estilo.columnGap || estilo.gap) || 0;
    return card.getBoundingClientRect().width + vao;
  }

  function liga(secao) {
    if (secao.dataset.fbKitLigado === '1') return;
    secao.dataset.fbKitLigado = '1';

    var trilha = secao.querySelector('.fb-kit__trilha');
    if (!trilha) return;

    var caixaProgresso = secao.querySelector('[data-fb-kit-progresso]');
    var barra = caixaProgresso ? caixaProgresso.querySelector('span') : null;
    var pedido = false;

    function pinta() {
      pedido = false;
      /* no editor de temas a secao pode sair do DOM antes do quadro seguinte */
      if (!secao.isConnected) return;
      var total = trilha.scrollWidth;
      if (!total) return;
      var fim = Math.min(trilha.scrollLeft + trilha.clientWidth, total);
      var fracao = Math.max(0, Math.min(1, fim / total));
      if (barra) barra.style.transform = 'scaleX(' + fracao.toFixed(4) + ')';
      if (caixaProgresso) {
        caixaProgresso.setAttribute('aria-valuenow', String(Math.round(fracao * 100)));
      }
    }

    function agenda() {
      if (pedido) return;
      pedido = true;
      window.requestAnimationFrame(pinta);
    }

    trilha.addEventListener('scroll', agenda, { passive: true });
    window.addEventListener('resize', agenda);
    window.addEventListener('load', agenda);

    function rola(direcao) {
      trilha.scrollBy({ left: direcao * passoDe(trilha), behavior: 'smooth' });
    }

    var setas = secao.querySelectorAll('[data-fb-kit-seta]');
    Array.prototype.forEach.call(setas, function (botao) {
      botao.addEventListener('click', function () {
        rola(botao.getAttribute('data-fb-kit-seta') === 'ant' ? -1 : 1);
      });
    });

    /* teclado: so quando o foco esta na propria trilha, para nao roubar as
       setas de quem esta navegando entre os "+" dos cards */
    trilha.addEventListener('keydown', function (e) {
      if (e.target !== trilha) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); rola(1); return; }
      if (e.key === 'ArrowLeft') { e.preventDefault(); rola(-1); return; }
      if (e.key === 'Home') { e.preventDefault(); trilha.scrollTo({ left: 0, behavior: 'smooth' }); return; }
      if (e.key === 'End') { e.preventDefault(); trilha.scrollTo({ left: trilha.scrollWidth, behavior: 'smooth' }); }
    });

    /* details/summary ja anuncia o estado sozinho, mas o aria-expanded fica
       explicito no summary porque nem todo leitor de tela mapeia isso */
    var infos = secao.querySelectorAll('details.fb-kit__info');
    Array.prototype.forEach.call(infos, function (info) {
      var summary = info.querySelector('.fb-kit__barra');
      if (!summary) return;
      summary.setAttribute('aria-expanded', info.open ? 'true' : 'false');
      info.addEventListener('toggle', function () {
        summary.setAttribute('aria-expanded', info.open ? 'true' : 'false');
      });
    });

    pinta();
  }

  function ligaTodos(raiz) {
    (raiz || document).querySelectorAll('[data-fb-kit]').forEach(liga);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { ligaTodos(); });
  } else {
    ligaTodos();
  }
  /* editor de temas: a secao e reinjetada sem recarregar a pagina */
  document.addEventListener('shopify:section:load', function (e) { ligaTodos(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fb-motivos"] && !Shopify.designMode) return;
  try {
    
/* Arrastar com o mouse na faixa de cards. O toque e a roda do mouse ja funcionam
   pela rolagem nativa; isto so cobre o desktop, onde o Swiper original permitia
   arrastar. Sem biblioteca externa. */
(function () {
  function liga(faixa) {
    if (faixa.dataset.fbLigado === '1') return;
    faixa.dataset.fbLigado = '1';

    var arrastando = false;
    var moveu = false;
    var xInicial = 0;
    var scrollInicial = 0;

    faixa.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return; // o toque usa a rolagem nativa
      arrastando = true;
      moveu = false;
      xInicial = e.clientX;
      scrollInicial = faixa.scrollLeft;
    });

    faixa.addEventListener('pointermove', function (e) {
      if (!arrastando) return;
      var dx = e.clientX - xInicial;
      if (!moveu && Math.abs(dx) > 4) {
        moveu = true;
        faixa.classList.add('is-arrastando');
        if (faixa.setPointerCapture) faixa.setPointerCapture(e.pointerId);
      }
      if (moveu) {
        faixa.scrollLeft = scrollInicial - dx;
        e.preventDefault();
      }
    });

    function solta() {
      if (!arrastando) return;
      arrastando = false;
      faixa.classList.remove('is-arrastando');
    }

    faixa.addEventListener('pointerup', solta);
    faixa.addEventListener('pointercancel', solta);
    faixa.addEventListener('pointerleave', solta);

    // Setas do teclado: avanca ou volta a largura de um card.
    faixa.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var slide = faixa.querySelector('.swiper-slide');
      var passo = slide ? slide.getBoundingClientRect().width + 16 : 320;
      faixa.scrollBy({ left: e.key === 'ArrowRight' ? passo : -passo, behavior: 'smooth' });
      e.preventDefault();
    });
  }

  function ligaTodos(raiz) {
    (raiz || document).querySelectorAll('.scroll-cards__slider[data-fb-carrossel]').forEach(liga);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { ligaTodos(); });
  } else {
    ligaTodos();
  }
  // Editor de temas: a secao e reinjetada sem recarregar a pagina.
  document.addEventListener('shopify:section:load', function (e) { ligaTodos(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fb-nav-lp"] && !Shopify.designMode) return;
  try {
    
/* Menu da landing page: hamburguer e rolagem ate a secao de destino.

   Tudo por delegacao no document e protegido por uma trava global. O bloco de
   JS da secao e concatenado pela Shopify num arquivo unico, executado uma vez
   por pagina, entao recarregar a secao no editor de temas (shopify:section:load)
   nao reexecuta este codigo nem duplica listener. O handler de section:load so
   existe para reajustar os href e zerar o estado do menu depois do rerender. */
(function () {
  if (window.fbNavLpPronto) return;
  window.fbNavLpPronto = true;

  var SEL_MOBILE = '[data-fb-nav-lp-mobile]';
  var CLASSE_ABERTO = 'header__lpMobile--open';

  function movimentoReduzido() {
    return (
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  /* querySelector explode com seletor invalido, e o campo do destino e um texto
     livre no editor. Aqui isso vira "nao achei", sem erro no console. */
  function acharDestino(seletor) {
    if (!seletor) return null;
    try {
      return document.querySelector(seletor);
    } catch (e) {
      return null;
    }
  }

  function fecharMenu(mobile, devolverFoco) {
    if (!mobile || !mobile.classList.contains(CLASSE_ABERTO)) return;
    mobile.classList.remove(CLASSE_ABERTO);
    var botao = mobile.querySelector('[data-fb-nav-lp-hamburguer]');
    if (botao) {
      botao.setAttribute('aria-expanded', 'false');
      if (devolverFoco) botao.focus();
    }
  }

  /* A barra e fixa no topo, entao o destino precisa parar abaixo dela. A altura
     e medida na hora com getBoundingClientRect porque muda entre desktop e
     mobile (e com o zoom do navegador). Nada de numero fixo. */
  function alturaDaBarra(referencia) {
    var barra = referencia && referencia.closest ? referencia.closest('.header__lpWrap') : null;
    if (!barra) barra = document.querySelector('.header__lpWrap');
    if (!barra) return 0;
    return barra.getBoundingClientRect().height || 0;
  }

  function rolarAte(alvo, referencia) {
    var topo = window.pageYOffset + alvo.getBoundingClientRect().top - alturaDaBarra(referencia);
    if (topo < 0) topo = 0;
    if (movimentoReduzido()) {
      window.scrollTo(0, topo);
    } else {
      window.scrollTo({ top: topo, behavior: 'smooth' });
    }
  }

  /* Deixa o href apontando para um id de verdade quando existir um, para o
     teclado e o botao do meio do mouse continuarem funcionando. Se o destino
     nao tem id proprio, vale o id do ancestral mais proximo, que na Shopify e
     o wrapper shopify-section-*. Sem id nenhum, fica em "#". */
  function sincronizarHrefs(raiz) {
    var escopo = raiz && raiz.querySelectorAll ? raiz : document;
    var links = escopo.querySelectorAll('[data-destino]');
    for (var i = 0; i < links.length; i++) {
      var alvo = acharDestino(links[i].getAttribute('data-destino'));
      var comId = alvo ? (alvo.id ? alvo : alvo.closest('[id]')) : null;
      links[i].setAttribute('href', comId && comId.id ? '#' + comId.id : '#');
    }
  }

  document.addEventListener('click', function (evt) {
    var alvoClique = evt.target;
    if (!alvoClique || typeof alvoClique.closest !== 'function') return;

    var botao = alvoClique.closest('[data-fb-nav-lp-hamburguer]');
    if (botao) {
      var mobile = botao.closest(SEL_MOBILE);
      if (!mobile) return;
      var abriu = mobile.classList.toggle(CLASSE_ABERTO);
      botao.setAttribute('aria-expanded', abriu ? 'true' : 'false');
      return;
    }

    var link = alvoClique.closest('[data-destino]');
    if (!link) return;

    /* Deixa passar clique com modificador e clique que nao e o botao esquerdo:
       quem quer abrir em outra aba continua conseguindo. */
    if (evt.button !== 0 || evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey) return;

    var destino = acharDestino(link.getAttribute('data-destino'));

    /* Sem destino na pagina o link nao faz nada: nem rola, nem pula para o topo
       por causa do href="#", nem reclama no console. */
    if (!destino) {
      evt.preventDefault();
      fecharMenu(link.closest(SEL_MOBILE), false);
      return;
    }

    evt.preventDefault();
    /* Fecha antes de medir: com o menu aberto a barra continua com a mesma
       altura (o painel e fixed, fora do fluxo), mas fechar primeiro evita o
       painel cobrir a secao no fim da rolagem. */
    fecharMenu(link.closest(SEL_MOBILE), false);
    rolarAte(destino, link);
  });

  document.addEventListener('keydown', function (evt) {
    if (evt.key !== 'Escape' && evt.key !== 'Esc') return;
    var abertos = document.querySelectorAll(SEL_MOBILE + '.' + CLASSE_ABERTO);
    for (var i = 0; i < abertos.length; i++) fecharMenu(abertos[i], true);
  });

  document.addEventListener('shopify:section:load', function (evt) {
    var raiz = evt.target && evt.target.querySelector ? evt.target : document;
    if (!raiz.querySelector('[data-fb-nav-lp-mobile]')) return;
    var mobile = raiz.querySelector(SEL_MOBILE);
    if (mobile) fecharMenu(mobile, false);
    sincronizarHrefs(document);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      sincronizarHrefs(document);
    });
  } else {
    sincronizarHrefs(document);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
(function () {
  var LARGURA = 749;
  var pronto = false;

  function ehMobile() {
    return window.matchMedia('(max-width: ' + LARGURA + 'px)').matches;
  }

  function titulo(el) {
    return el.querySelector('.footer-block__heading');
  }

  function alterna(bloco) {
    var aberto = bloco.classList.toggle('fb-aberto');
    var h = titulo(bloco);
    if (h) h.setAttribute('aria-expanded', aberto ? 'true' : 'false');
  }

  function preparar() {
    var blocos = document.querySelectorAll('.footer-block--menu');
    for (var i = 0; i < blocos.length; i++) {
      var h = titulo(blocos[i]);
      if (!h || h.dataset.fbAcordeao) continue;
      h.dataset.fbAcordeao = '1';
      h.setAttribute('role', 'button');
      h.setAttribute('tabindex', '0');
      h.setAttribute('aria-expanded', 'false');
    }
  }

  function aoClicar(e) {
    if (!ehMobile()) return;
    var h = e.target.closest ? e.target.closest('.footer-block__heading') : null;
    if (!h) return;
    var bloco = h.closest('.footer-block--menu');
    if (!bloco) return;
    e.preventDefault();
    alterna(bloco);
  }

  function aoTeclar(e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    if (!ehMobile()) return;
    var h = e.target.closest ? e.target.closest('.footer-block__heading') : null;
    if (!h || !h.dataset.fbAcordeao) return;
    var bloco = h.closest('.footer-block--menu');
    if (!bloco) return;
    e.preventDefault();
    alterna(bloco);
  }

  function iniciar() {
    preparar();
    if (pronto) return;
    pronto = true;
    document.addEventListener('click', aoClicar);
    document.addEventListener('keydown', aoTeclar);
    // Voltando para desktop, nada fica escondido por causa de estado antigo.
    window.addEventListener('resize', function () {
      if (ehMobile()) return;
      var abertos = document.querySelectorAll('.footer-block--menu.fb-aberto');
      for (var i = 0; i < abertos.length; i++) abertos[i].classList.remove('fb-aberto');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
  document.addEventListener('shopify:section:load', iniciar);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
    }

    onManagedReset() {
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
